import { useEffect } from "react";
import PropTypes from "prop-types";

const MikMakScript = ({ appId }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      (function(e,d){
        try {
          var a = window.swnDataLayer = window.swnDataLayer || {};
          a.appId = e || a.appId;
          a.eventBuffer = a.eventBuffer || [];
          a.loadBuffer = a.loadBuffer || [];
          a.push = a.push || function(e) { a.eventBuffer.push(e) };
          a.load = a.load || function(e) { a.loadBuffer.push(e) };
          a.dnt = a.dnt != null ? a.dnt : d;
          var t = document.getElementsByTagName("script")[0],
              n = document.createElement("script");
          n.async = true;
          n.src = "//wtb-tag.mikmak.ai/scripts/" + a.appId + "/tag.min.js";
          t.parentNode.insertBefore(n, t);
        } catch(e) {
          console.log(e);
        }
      })("${appId}", false);
    `;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [appId]);

  return null;
};

MikMakScript.propTypes = {
  appId: PropTypes.string.isRequired,
};

export default MikMakScript;
